<template>
  <el-input id="scanned_value" v-model="_valueCode" type="text" placeholder="Scanned value" class="mr-2">
    <template #append>
      <el-button id="complete_scan" @click="completeScan" class="w-[52px] h-full bg-white text-black">
        {{ $t('ok') }}
      </el-button>
    </template>
  </el-input>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { PropSync } from 'vue-property-decorator'
@Options({
  emits: ['update:completeScan'],
  name: 'ScannedValueInput',
})
export default class ScannedValueInput extends Vue {
  @PropSync('valueCode', { type: String }) _valueCode!: string

  completeScan() {
    this.$emit('update:completeScan')
  }
}
</script>
